enum UserInviteType {
  workspaceMember = 'workspace_member',
  workspaceOwner = 'workspace_owner',
  workspaceTransferOwner = 'workspace_transfer_owner',
}

export default UserInviteType
